import { useState } from 'react';

import { StyledSidebar, StyledSidebarLink } from './StyledSidebar';
import { useSelector } from 'react-redux';

import { ReactComponent as ArrowIcon } from '../../Static/icons/arrow_small1.svg';

import { routes } from '../../Routes';

const sidebarLinks = routes
  .filter(({ sidebarLink = false }) => sidebarLink)
  .map(({ path, title, exact, roles }) => {
    return { path, title, exact, roles };
  });

export const Sidebar = () => {
  const [expanded, setExpanded] = useState(false);

  const handleClick = e => {
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const { role } = useSelector(({ user }) => user);
  return (
    <StyledSidebar
      className={expanded ? ' expanded' : ''}
      onClick={e => expanded && setTimeout(() => handleClick(e), 400)}
    >
      {sidebarLinks.map(({ path, title, exact, roles }, i) =>
        roles.some(_role => _role === role) ? (
          <li key={i}>
            <StyledSidebarLink to={path} activeClassName="active">
              {title}
            </StyledSidebarLink>
          </li>
        ) : null,
      )}
      <li className="icon" onClick={handleClick}>
        <ArrowIcon />
      </li>
    </StyledSidebar>
  );
};
